export const TRACKED_EVENTS = {
  actions: {
    plan_select: 'Action:SelectPlan',
    compare_packages: 'Action:ComparePackages',
    choose_package: 'Action:ChoosePackage',
    tax_exempt: 'Action:TaxExempt',
    update_card: 'Action:UpdateCard',
    cta_click: 'Action:CTAClick',
    choose_package_enter_view: 'Action:ChoosePackageEnterView',
    choose_package_exit_view: 'Action:ChoosePackageExitView',
    choose_package_cta_click: 'Action:ChoosePackageCTAClick',
    promo_code: 'Action:PromoCode',
    submit_checkout: 'Action:SubmitCheckout',
    save_card_submit: 'Action:SaveCardSubmit',
    save_card_submit_error: 'Action:SaveCardSubmitError',
    finalise_checkout: 'Action:FinaliseCheckout',
    addons: 'Action:Add-ons',
    billing_method: 'Action:Billing',
    checkout_complete: 'Action:Checkout',
  },
  identifiers: {
    catalogue_flags: 'Identify:CatalogueFlags',
  },
};
